import { Box, Button, Typography, ButtonBase } from "@mui/material";
import React from "react";
import { Skeleton } from "@mui/material";
import { Header } from "../../components/Header";
import { Footer } from "../../components/Footer";
import { Navigation } from "../../components/Navigation";
import { Body } from "../../components/Body";
import { brands, globalWordings } from "../../data";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation as SwiperNavigation } from "swiper/modules";
import { useIsDesktop } from "../../utils/useIsDesktop";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "../../components/Helmet";
import { useBrandContext } from "../../App";
import { AgeDisclaimer } from "../../components/AgeDisclaimer";
import "swiper/swiper-bundle.css";
import "./slider.css";
import { useLangRedirection } from "../../hooks/useLangRedirection";

export const Home = () => {
  useLangRedirection();
  const { lang } = useParams();
  const { brand } = useBrandContext();
  const isDesktop = useIsDesktop();
  const config = {
    spaceBetween: isDesktop ? -300 : -240,
    slidesPerView: isDesktop ? 3 : 1,
    navigation: true,
  };

  return (
    <Box>
      <Helmet
        title={`${brands[brand].name} | ${globalWordings[lang].selectYourProduct}`}
      />
      <Header brand={brand} />
      <Navigation title={globalWordings[lang].selectYourProduct} />

      <Body>
        <Box sx={{ width: { xs: "calc(100% + 32px)", md: "auto" }, ml: -2 }}>
          <Swiper
            modules={[Pagination, SwiperNavigation]}
            className="mySwiper"
            centeredSlides={true}
            {...config}
          >
            {brands[brand].products.map((product, index) => (
              <SwiperSlide key={index}>
                {({ isActive }) => (
                  <ItemSwipe
                    title={product.name[lang]}
                    description={product.description[lang]}
                    to={`/${lang}/${brand}/details/${product.id}`}
                    image={product.image[lang]}
                    active={isActive}
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Body>

      <Footer />
      <AgeDisclaimer />
    </Box>
  );
};

const ItemSwipe = ({ title, description, to, image, active }) => {
  const { lang } = useParams();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <ButtonBase onClick={handleClick}>
        <React.Suspense
          fallback={
            <Skeleton
              variant="rectangular"
              width={{ xs: 220, md: 316 }}
              height={{ xs: 220, md: 316 }}
            />
          }
        >
          <Box
            component="img"
            sx={{
              objectFit: "cover",
              objectPosition: "center",
              height: { xs: 220, md: 316 },
              width: { xs: 220, md: 316 },
              transform: !active ? "scale(0.7)" : "scale(1)",
              transition: "all 0.3s ease-in-out",
              opacity: active ? 1 : 0.5,
            }}
            src={image}
            alt={`${title} image`}
            loading="lazy"
          />
        </React.Suspense>
      </ButtonBase>

      {active && (
        <Box py={4}>
          <Box gap={2} px={4} mt={2.5} display="flex" flexDirection="column">
            <Typography
              variant="heavy-bold"
              fontSize={31}
              sx={{ textTransform: "uppercase" }}
            >
              {title}
            </Typography>
            <Typography variant="caption">{description}</Typography>
          </Box>

          <Button
            variant="contained"
            sx={{ mt: { xs: 5, md: 10 } }}
            onClick={handleClick}
          >
            {globalWordings[lang].moreInformation}
          </Button>
        </Box>
      )}
    </Box>
  );
};
